import script from "./Disclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./Disclaimer.vue?vue&type=script&setup=true&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=276520a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276520a6"]])

export default __exports__